module.exports = __webpack_public_path__ + "img/01.08891c46.png";